import { render, staticRenderFns } from "./zhaoshangtupu.vue?vue&type=template&id=0b3e2614&scoped=true&"
import script from "./zhaoshangtupu.vue?vue&type=script&lang=js&"
export * from "./zhaoshangtupu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3e2614",
  null
  
)

export default component.exports